module.exports = __webpack_public_path__ + "img/zljy.0e06374f.jpg";